/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { IntegrationCheckStatus } from "./IntegrationCheckStatus";
import {
  IntegrationCheckStatusFromJSON,
  IntegrationCheckStatusFromJSONTyped,
  IntegrationCheckStatusToJSON,
  IntegrationCheckStatusToJSONTyped,
} from "./IntegrationCheckStatus";
import type { IntegrationCheckOwner } from "./IntegrationCheckOwner";
import {
  IntegrationCheckOwnerFromJSON,
  IntegrationCheckOwnerFromJSONTyped,
  IntegrationCheckOwnerToJSON,
  IntegrationCheckOwnerToJSONTyped,
} from "./IntegrationCheckOwner";

/**
 *
 * @export
 * @interface BigCommerceHealthcheckItem
 */
export interface BigCommerceHealthcheckItem {
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckItem
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckItem
   */
  name: string;
  /**
   *
   * @type {IntegrationCheckStatus}
   * @memberof BigCommerceHealthcheckItem
   */
  status: IntegrationCheckStatus;
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckItem
   */
  detail: string;
  /**
   *
   * @type {IntegrationCheckOwner}
   * @memberof BigCommerceHealthcheckItem
   */
  owner: IntegrationCheckOwner;
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckItem
   */
  merchantDetail?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof BigCommerceHealthcheckItem
   */
  inferred: boolean;
}

/**
 * Check if a given object implements the BigCommerceHealthcheckItem interface.
 */
export function instanceOfBigCommerceHealthcheckItem(
  value: object,
): value is BigCommerceHealthcheckItem {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("detail" in value) || value["detail"] === undefined) return false;
  if (!("owner" in value) || value["owner"] === undefined) return false;
  if (!("inferred" in value) || value["inferred"] === undefined) return false;
  return true;
}

export function BigCommerceHealthcheckItemFromJSON(
  json: any,
): BigCommerceHealthcheckItem {
  return BigCommerceHealthcheckItemFromJSONTyped(json, false);
}

export function BigCommerceHealthcheckItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceHealthcheckItem {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
    status: IntegrationCheckStatusFromJSON(json["status"]),
    detail: json["detail"],
    owner: IntegrationCheckOwnerFromJSON(json["owner"]),
    merchantDetail:
      json["merchantDetail"] == null ? undefined : json["merchantDetail"],
    inferred: json["inferred"],
  };
}

export function BigCommerceHealthcheckItemToJSON(
  json: any,
): BigCommerceHealthcheckItem {
  return BigCommerceHealthcheckItemToJSONTyped(json, false);
}

export function BigCommerceHealthcheckItemToJSONTyped(
  value?: BigCommerceHealthcheckItem | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    name: value["name"],
    status: IntegrationCheckStatusToJSON(value["status"]),
    detail: value["detail"],
    owner: IntegrationCheckOwnerToJSON(value["owner"]),
    merchantDetail: value["merchantDetail"],
    inferred: value["inferred"],
  };
}
